import { render } from "./RegistroAnunciante.vue?vue&type=template&id=90f0e9b0&scoped=true"
import script from "./RegistroAnunciante.vue?vue&type=script&lang=js"
export * from "./RegistroAnunciante.vue?vue&type=script&lang=js"

import "./RegistroAnunciante.vue?vue&type=style&index=0&id=90f0e9b0&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f0e9b0"]])

export default __exports__